import { h } from 'preact'
import logoJo2024 from './logo-paris-2024-orange.png'

export const Jo2024 = () => {
   return (
      <div class="jo-2024" data-testid="bande-jo-2024">
         <a href="https://paris2024.orange.fr/?utx_source=Paris2024&utx_medium=logo&utx_campaign=hp">
            <img src={logoJo2024} alt="Paris 2024 - Orange Partenaire Premium" loading="lazy" />
         </a>
      </div>
   )
}
